<button
  type="button"
  class="layer_details__action layer_details__action--edit layer_details__copy select-none"
  (click)="copyClicked.emit()"
>
  Copy
</button>
